export interface IScreeningQueueItem {
  uid: string
  status: (typeof EScreeningStatus)[keyof typeof EScreeningStatus]
  gender: string
  visit_id: string
  fio_initials: string
  birth_date: string
  donation_type_id: string
  visit_type_id: string
  donor_category_id: string
  is_mobile_collection: boolean
  is_fast_tracked: boolean
  queued_at: string
}

export const EScreeningStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED', // Годен
  WAITING: 'WAITING',
  DEFERRED: 'DEFERRED', // Не годен
} as const

export type TScreeningStatus =
  (typeof EScreeningStatus)[keyof typeof EScreeningStatus]

export const EScreeningHistoryStatus = {
  SUITABLE: 'SUITABLE', // Годен
  DEFERRED: 'DEFERRED', // Не годен
} as const

export type TScreeningHistoryStatus =
  (typeof EScreeningHistoryStatus)[keyof typeof EScreeningHistoryStatus]
export interface IScreeningQueueParams {
  visit_type_id?: string
  status?: TScreeningStatus
  donation_type_id?: string
  donor_category_id?: string
  gender?: string
  is_mobile_collection?: boolean
  search?: string
  /** Spring-style sort expression, e.g. `queued_at,desc`. Defaults to newest first. */
  sort?: string
  page: number
  size: number
}

export interface IScreeningResultsPayload {
  hemoglobin: number
  blood_group_id: string
  rh_factor_id: string
}

export interface IScreeningResultsData {
  result: string
  message: string
  visit_id: string
  screening_id: string
  id_card_status: string
  is_preliminary: boolean
}

export interface IScreeningResultsResponse {
  success: boolean
  data: IScreeningResultsData
  errors: {
    code: string
    message: string
    fields: { key: string; value: string }[]
  }[]
  meta: {
    timestamp: string
    request_id: string
    execution_time_ms: number
  }
}

export interface IScreeningHistoryItem {
  hemoglobin: 0
  result: TScreeningHistoryStatus
  screening_id: string
  visit_id: string
  nurse_fio?: string
  donor_id: string
  blood_group_id: string
  blood_group_name: string
  blood_group_code: string
  rh_factor_id: string
  rh_factor_code: string
  rh_factor_name: string
  screened_at: string
}

export interface IScreeningQueueResponse {
  success: boolean
  data: IScreeningQueueItem[]
  errors: {
    code: string
    message: string
    fields: { key: string; value: string }[]
  }[]
  meta: { timestamp: string; request_id: string }
  page: number
  hasNext: boolean
  totalSize: number
  totalPages: number
}
